export default "__VITE_ASSET__DBwo6mB0__"